import { menuAnatomy } from "@chakra-ui/anatomy";
//@ts-ignore
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(menuAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  // define the part you're going to style
  button: {
    // this will style the MenuButton component
    type: "button",
    fontWeight: "medium",
    bg: "teal.300",
    color: "white",
    width: "10.5rem",
    h: "2.3rem",
    borderRadius: "2rem",
    _hover: {
      bg: "teal.200",

      // color: "white",
    },
    _active: {
      bg: "teal.400",
    },
  },
  list: {
    // this will style the MenuList component
    // py: "4",
    boxShadow: "-1px 2px 8px #156460",
    borderRadius: "xl",
    border: "none",
    // bg: "teal.500",
    maxHeight: "30vh",
    overflowY: "auto",
    zIndex: 1000,
    direction: "ltr",
  },
  item: {
    // this will style the MenuItem and MenuItemOption components
    // color: "white ",
    textAlign: "right",
    border: "none",
    _hover: {
      bg: "teal.100",
    },

    _focus: {
      bg: "teal.100",
    },
  },
});
// export the base styles in the component theme
export const menuTheme = defineMultiStyleConfig({ baseStyle });
